import { ReactNode } from "react";
import { Card } from "@/components/ui/card";

interface QuestionCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const QuestionCard = ({ title, subtitle, children }: QuestionCardProps) => {
  return (
    <Card className="w-full max-w-2xl mx-auto p-8 shadow-lg animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="space-y-6">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold text-foreground">{title}</h2>
          {subtitle && (
            <p className="text-lg text-muted-foreground">{subtitle}</p>
          )}
        </div>
        <div className="pt-4">{children}</div>
      </div>
    </Card>
  );
};

export default QuestionCard;
